module.exports = __webpack_public_path__ + "static/media/bxcoach-card.03f4acb0.png";